import React, { useEffect, useState, useRef } from 'react';
import { Plus, Trash2, X, Check, Upload, Image } from 'lucide-react';
import { galeriaService } from '../../services/api';
import toast from 'react-hot-toast';

export default function AdminGaleria() {
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ titulo:'', descricao:'' });
  const [arquivo, setArquivo] = useState<File|null>(null);
  const [preview, setPreview] = useState('');
  const fileRef = useRef<HTMLInputElement>(null);

  const load = () => { setLoading(true); galeriaService.listar().then(r=>setItems(Array.isArray(r.data)?r.data:r.data.fotos||[])).catch(()=>toast.error('Erro')).finally(()=>setLoading(false)); };
  useEffect(load,[]);
  const onChange = (e:any) => setForm(f=>({...f,[e.target.name]:e.target.value}));
  const onFile = (e:any) => { const f=e.target.files?.[0]; if(f){setArquivo(f);setPreview(URL.createObjectURL(f));} };

  const salvar = async () => {
    if(!arquivo){ toast.error('Selecione uma imagem'); return; }
    setSaving(true);
    try {
      const fd=new FormData(); Object.entries(form).forEach(([k,v])=>fd.append(k,v as string)); fd.append('imagem',arquivo);
      await galeriaService.criar(fd);
      toast.success('Foto adicionada!'); setModal(false); setArquivo(null); setPreview(''); setForm({titulo:'',descricao:''}); load();
    } catch { toast.error('Erro ao enviar.'); } finally { setSaving(false); }
  };

  const deletar = async (id:string) => { if(!window.confirm('Excluir foto?')) return; try { await galeriaService.deletar(id); toast.success('Excluída!'); load(); } catch { toast.error('Erro.'); } };

  return (
    <div>
      <div className="admin-page-header"><h1>Galeria</h1><button className="btn btn-primary" onClick={()=>setModal(true)}><Plus size={17}/> Adicionar foto</button></div>
      {loading ? <div className="loading-center"><div className="spinner"/></div> : items.length===0 ? (
        <div className="loading-center"><Image size={48} style={{color:'var(--borda)'}}/><p>Nenhuma foto na galeria.</p></div>
      ) : (
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(180px,1fr))',gap:12}}>
          {items.map(item=>(
            <div key={item._id} style={{position:'relative',borderRadius:'var(--radius-lg)',overflow:'hidden',background:'var(--creme-escuro)'}}>
              <img src={item.urlPublica||item.imagemUrl} alt={item.titulo} style={{width:'100%',height:160,objectFit:'cover',display:'block'}}/>
              <button onClick={()=>deletar(item._id)} style={{position:'absolute',top:8,right:8,background:'rgba(0,0,0,0.6)',border:'none',borderRadius:8,width:30,height:30,display:'flex',alignItems:'center',justifyContent:'center',color:'white',cursor:'pointer'}}><Trash2 size={14}/></button>
              {item.titulo&&<div style={{position:'absolute',bottom:0,left:0,right:0,background:'linear-gradient(transparent,rgba(0,0,0,0.7))',padding:'20px 10px 8px'}}><p style={{color:'white',fontSize:'0.78rem',margin:0}}>{item.titulo}</p></div>}
            </div>
          ))}
        </div>
      )}
      {modal&&(
        <div className="admin-modal-overlay" onClick={()=>setModal(false)}>
          <div className="admin-modal" style={{maxWidth:480}} onClick={e=>e.stopPropagation()}>
            <div className="admin-modal-header"><h3>Adicionar Foto</h3><button className="modal-close" onClick={()=>setModal(false)}><X size={20}/></button></div>
            <div className="admin-modal-body">
              <div className="form-group">
                <label className="form-label">Imagem *</label>
                <div className="img-upload-area" onClick={()=>fileRef.current?.click()}>
                  {preview?<img src={preview} alt="" style={{width:'100%',height:'100%',objectFit:'cover',borderRadius:'var(--radius)'}}/>:<div className="img-upload-placeholder"><Upload size={24}/><span>Clique para selecionar</span></div>}
                </div>
                <input ref={fileRef} type="file" accept="image/*" style={{display:'none'}} onChange={onFile}/>
              </div>
              <div className="form-group"><label className="form-label">Título</label><input name="titulo" value={form.titulo} onChange={onChange} className="form-control" placeholder="Descrição curta"/></div>
              <div className="form-group"><label className="form-label">Descrição</label><textarea name="descricao" value={form.descricao} onChange={onChange} className="form-control" rows={2}/></div>
            </div>
            <div className="admin-modal-footer">
              <button className="btn btn-outline" onClick={()=>setModal(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={salvar} disabled={saving}>{saving?'Enviando…':<><Check size={16}/> Adicionar</>}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
